import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = ({
  isFormMicroCenterActive,
}: { isFormMicroCenterActive?: boolean } = {}) =>
  makeStyles(({ breakpoints }: Theme) => ({
    container: {
      display: 'flex',
      alignItems: 'flex-end',
      [breakpoints.down(1024)]: {
        marginTop: 15,
        flexDirection: 'row-reverse',
        position: 'relative',
        margin: 0,
        bottom: 0,
        alignItems: 'center',
        justifyContent: 'center',
      },
      ...(!isFormMicroCenterActive && {
        position: 'absolute',
        right: 0,
        bottom: -86,
        margin: '0 20px',
        [breakpoints.down(500)]: {
          flexDirection: 'row',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          marginTop: -47,
        },
      }),
    },
    recommendationSign: {
      marginBottom: 32,
      [breakpoints.down(1024)]: {
        marginBottom: 0,
      },
    },
    photo: {
      marginLeft: 16,
      [breakpoints.down(1024)]: {
        marginLeft: 0,
      },
    },
  }));
